import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import {
  getDeptos,
  deleteDepto,
  putDepto,
} from "../helpers/rutaDeptos";
import "../css/tableclientes.css";

const TableDeptos = () => {
  const [deptos, setDeptos] = useState({
    data: [],
    loading: true,
  });

  const [show, setShow] = useState(false);
  const [deptoSeleccionado, setDeptoSeleccionado] = useState(null);
  const [formValues, setFormValues] = useState({
    depto: "",
    activo: true,
  });

  useEffect(() => {
    consultaDeptos();
  }, []);

  const consultaDeptos = () => {
    getDeptos().then((datos) => {
      console.log("GET DEPTOS:", datos);

      setDeptos({
        data: Array.isArray(datos?.deptos)
          ? datos.deptos
          : Array.isArray(datos)
          ? datos
          : [],
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    setDeptoSeleccionado(null);
    setFormValues({
      depto: "",
      activo: true,
    });
    consultaDeptos();
  };

  const modificaDepto = (item) => {
    console.log("DEPTO SELECCIONADO:", item);

    setDeptoSeleccionado(item);
    setFormValues({
      depto: item?.depto || "",
      activo: typeof item?.activo === "boolean" ? item.activo : true,
    });
    setShow(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!deptoSeleccionado?._id) {
      alert("No se encontró el id del depto");
      return;
    }

    try {
      const payload = {
        depto: formValues.depto,
        activo: formValues.activo,
      };

      const resp = await putDepto(deptoSeleccionado._id, payload);
      console.log("✅ Depto actualizado:", resp);

      if (resp?.ok === false) {
        alert(resp?.error?.message || resp?.error || "Error al actualizar depto");
        return;
      }

      handleClose();
    } catch (error) {
      console.error("❌ Error al actualizar depto:", error);
      alert("Error al actualizar depto");
    }
  };

  const eliminarDepto = (id) => {
    const validar = window.confirm("¿Está seguro que desea borrar el depto?");
    if (validar) {
      deleteDepto(id).then((resp) => {
        console.log(resp);
        consultaDeptos();
      });
    }
  };

  return (
    <div className="table-container">
      {!deptos.loading && (
        <>
          <div className="col-12 mt-4"></div>

          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th className="cli">Deptos</th>
                  <th>Modif/Eliminar</th>
                </tr>
              </thead>

              <tbody>
                {deptos.data.map((item) =>
                  item.activo !== false ? (
                    <tr key={item._id}>
                      <td>{item.depto}</td>
                      <td>
                        <button
                          id="acepto"
                          className="btn btn-primary"
                          onClick={() => modificaDepto(item)}
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                          ></i>
                        </button>

                        <button
                          id="acepto"
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarDepto(item._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <Modal show={show} onHide={handleClose} centered>
            <form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Modificar Depto</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div className="form-group mt-2">
                  <label>Depto</label>
                  <input
                    type="text"
                    className="form-control"
                    name="depto"
                    required
                    maxLength="30"
                    minLength="2"
                    value={formValues.depto}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group mt-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="activo"
                      id="activoDepto"
                      checked={formValues.activo}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="activoDepto">
                      Activo
                    </label>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button type="submit" variant="dark">
                  Guardar
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </>
      )}
    </div>
  );
};

export default TableDeptos;